<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<app-breadcrumb></app-breadcrumb>
<div class="menu-container">
  <div class="row menu-row-container">
    <div class="col-sm-6 gridName-container">
      <span class="gridName">Search</span>
    </div>
  </div>
</div>
<div class="table-container">
  <div id="header-container" class="row">
    <div class="row" style="margin-bottom: 10px;">
      <div class="col-md-6" style="height:40px;border:1px solid #0b095e;padding-left: 1px;border-radius: 5px;">
        <div class="row">
          <div class="col-md-4" style="padding-left: 0px;">
            <button mat-stroked-button style="border:none;color: black;height: 39px;font-size: 13px;">Search Document
              By</button>
          </div>

          <div class="col-md-4 trainingDashboard" style="margin-left: -10%;">
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedSearchValue" (closed)="documentSearchText=''"
              (click)="focusSearch('focus-document-by-search')" (keydown.enter)="focusSearch('focus-document-by-search')">
              <input type="search" id="focus-document-by-search" class="dropdownsearchstyle"
                [(ngModel)]="documentSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of dropDownForSearchValue | assessmentSearch : documentSearchText;"
                [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-3 " style="width: 38%;">
            <input style="margin-top: 1px;" class="input-filed-continers" type="text" [(ngModel)]="docIdOrName"
              placeholder="{{selectedSearchValue[0].displayExp}}">
          </div>
          <div class="col-sm-1 "
            style="padding-left: 6%; margin-top: 1.5%; font-size: 18px; color: black; cursor: pointer;margin-left:-4%">
            <i class="fa fa-search" (click)="searchDocuments()" (keydown.enter)="searchDocuments()"></i>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<ng-template #searchedDocumentPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchedDocumentPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle">Documents</label>
      <label for="popup" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="table-container">
        <div class="header-container row">
          <div class="col-md-4">
            <div class="row-search-container">

              <input type="text" class="form-control" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue1">
            </div>
          </div>
          <div class="col-8 col-md-6pr-0 d-flex  justify-content-end align-items-center">

            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
            <div ngbDropdown class="d-inline-block leftpadding">
              <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic1" ngbDropdownToggle>
                {{perPage}}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              </div>
              per page
            </div>
          </div>
        </div>
        <table class="dynamic-table-container">
          <th> <span>Document No.</span> <span class="fa-solid fa-filter multi-filter-container" ></span> </th>
          <th> <span>Version</span> <span class="fa-solid fa-filter multi-filter-container" ></span> </th>
          <th> <span>Document Name</span> <span class="fa-solid fa-filter multi-filter-container" ></span> </th>
          <th> <span> Document Type</span> <span class="fa-solid fa-filter multi-filter-container" ></span> </th>
          <th> <span>Status</span> <span class="fa-solid fa-filter multi-filter-container" ></span> </th>
          <th> <span>Folder Path</span> <span class="fa-solid fa-filter multi-filter-container" ></span> </th>
          <th id="menu" class="sticky-col first-col"></th>
          <tr class="data-row-container"
            *ngFor="let document of pagedItems1 | searchFilter : searchValue1; let idx = index;">
            <td class="row-data"><span style="color: blue;text-decoration: underline;cursor: pointer;"
                (click)="goToSubfolderPageFromSearchedDoc(document)"
                (keydown.enter)="goToSubfolderPageFromSearchedDoc(document)">{{ document.documentNo }}</span></td>
            <td class="row-data">{{document.version}}</td>
            <td class="row-data">{{ document.documentName }}</td>
            <td class="row-data">{{ document.documentTypeName }}</td>
            <td class="row-data">{{ document.status }}</td>
            <td class="row-data">{{ document.folderPath }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</ng-template>